import React from "react";
import "./SectorsSection.css";

const EventCleaningTrustSection = () => {
  const sectors = [
    "Corporate Events",
    "Conferences & Seminars",
    "Trade Shows & Exhibitions",
    "Product Launches",
    "Board Meetings",
    "Annual General Meetings",
    "Training Programs",
    "Workshops & Webinars",
    "Awards Ceremonies",
    "Corporate Celebrations",
    "Networking Events",
    "Industry Conventions"
  ];

  return (
    <section className="sector-section-wrapper">
      <div className="sector-section-container">
        <h2 className="sector-section-title">Trusted Across Sectors</h2>
        <p className="sector-section-subtitle">
          Serving diverse industries with excellence
        </p>

        <div className="sector-tags-wrapper">
          {sectors.map((sector, index) => (
            <span key={index} className="sector-tag">
              {sector}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventCleaningTrustSection;
